<template>
	<div class="mainx font-inter">
    <div class="d-flex align-items-center justify-content-between">
	<div>
	  <BaseHeader title="Meus Contratos"></BaseHeader>
	  <b-breadcrumb
		:items="[{ text: 'Dashboard', href: '/dashboard' }, { text: $t('views.seller.reports.text_1428'), href: '/relatorios' }, { text: 'Meus Contratos' } ]"
		class="bg-white m-0 p-0"></b-breadcrumb>
	</div>
      <BaseNewButton
          variant="primary"
          @click.prevent="$bvModal.show('subscription-status-export-modal')"
      >
        Exportar Tabela
      </BaseNewButton>
    </div>
		<div class="divider"></div>

			<!-- Banner de migração, mantém o acesso ao antigo "Meus Contratos" até 15/01/26 -->
			<div v-if="showMigrationBanner" class="migration-banner p-3 rounded">
				<div class="d-flex align-items-center justify-content-between" style="gap:1rem;">
					<div class="migration-text">
						<strong>Essa é o novo relatório de Meus Contratos!</strong>
						<div>O relatório antigo será descontinuado em 15/01/26. Caso queira acessar o painel anterior, <router-link to="/contratos">clique aqui</router-link>.</div>
					</div>
				</div>
			</div>
		<div class="container-x">
      <ExportModal
        name="subscription-status-export-modal"
        :emailLabel="$t('seller.sales.text_2622')"
        :email="$store.getters.getProfile.email"
        :onSubmit="handleExport"
        :loading="exportLoading"
      />
			<div class="filters d-flex flex-wrap" style="gap:1rem;">
				<div>
					<ProductsFilter v-model="filterSearch.products" />
				</div>
				<div>
					<BaseDateRangePicker class="base-date-picker" v-model="filterSearch.dateRange"
						:placeholder="$t('views.seller.reports.text_1431')" />
				</div>
				<div>
					<multiselect v-model="subscriptionStatus.value" :options="subscriptionStatus.items" :multiple="true"
						:taggable="false" :show-labels="false" :clear-on-select="false" :close-on-select="false"
						:limit-text="(count) => `+ ${count}`" :limit="2" :group-select="true" :select-label="'Select'"
						class="new-style" group-values="options" group-label="group" placeholder="Status" track-by="name"
						label="name" style="min-width: 200px;" @input="handleMultiselectInput"
						@close="handleApplyFilterSubscriptionStatus" @remove="handleRemoveFilterSubscriptionStatus">
						<template #option="props">
							<span class="option__title" v-if="props.option?.$isLabel">
								{{ props.option.$groupLabel.name }}
								<span class="label-info label-info--deselected">{{
									$t('views.seller.integrations.config.save.product.select_all') }}</span>
								<span class="label-info label-info--selected">{{
									$t('views.seller.integrations.config.save.product.remove_all') }}</span>
							</span>
							<span class="d-flex option__item" v-else>
								<img :src="isOptionSelected('subscriptionStatus', props.option.id)" />
								{{ props.option.name }}
							</span>
						</template>
						<template #placeholder>
							<span class="select-title">Status</span>
						</template>
						<span slot="noOptions">{{ $t('views.seller.integrations.config.save.product.no_items') }}</span>
						<span slot="noResult">{{ $t('views.seller.integrations.config.save.product.no_content') }}</span>
						<div slot="limit" class="multiselect__tag limit">+{{ subscriptionStatus?.value?.length - 2 }}</div>
						<template #caret>
							<img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
						</template>
					</multiselect>
				</div>
        <ClientIdentifierInput
            v-model="clientIdentifier"
            id="clientIdentifier"
            name="clientIdentifier"
            :type.sync="clientIdentifierType"
            @input="debounce"
        />
				<div sm="1" md="1" class="mr-1 mr-md-1 my-2 mx-md-o my-md-0 p-0">
					<BaseNewButton variant="secondary" @click.prevent="openFiltersAdvanced" style="height: 38px !important;">
						{{ $t("common.text_0006") }}
					</BaseNewButton>
				</div>
				<div>
					<BaseNewButton variant="secondary" :disabled="!hasFilterFilled" @click.prevent="handleClearFilters"
						style="height: 38px !important;">
						{{ $t("common.text_0003") }}
					</BaseNewButton>
				</div>
			</div>

			<!-- Tags de filtros aplicados -->
			<div class="applied-filters"
				style="margin: 0px ; padding: 0; position: relative; top: -14px; display: flex; flex-wrap: wrap; gap: 8px;">

				<template v-for="product in filterSearch.products">
					<span v-if="product" :key="'product-' + product" class="tag" role="button"
						:title="$t('common.text_0003') + ' ' + getProductName(product)">
						{{ $t('common.text_0007') }}: {{ getProductName(product) }}
						<button type="button" class="tag-remove" @click="removeProduct(product)"
							:aria-label="$t('common.text_0003') + ' ' + getProductName(product)">
							×
						</button>
					</span>
				</template>

				<template v-for="offer in filterSearch.offers">
					<span v-if="offer" :key="'offer-' + offer" class="tag" role="button"
						:title="$t('common.text_0003') + ' ' + getOfferName(offer)">
						{{ $t('common.text_0008') }}: {{ getOfferName(offer) }}
						<button type="button" class="tag-remove" @click="removeOffer(offer)"
							:aria-label="$t('common.text_0003') + ' ' + getOfferName(offer)">
							×
						</button>
					</span>
				</template>

				<template v-for="status in filterSearch.subscriptionStatus">
					<span v-if="status" :key="'status-' + status" class="tag" role="button"
						:title="$t('common.text_0003') + ' ' + getStatusName(status)">
						{{ $t('common.text_0009') }}: {{ getStatusName(status) }}
						<button type="button" class="tag-remove" @click="removeStatus(status)"
							:aria-label="$t('common.text_0003') + ' ' + getStatusName(status)">
							×
						</button>
					</span>
				</template>

				<template v-for="contract in filterSearch.contracts">
					<span v-if="contract" :key="'contract-' + contract" class="tag" role="button"
						:title="$t('common.text_0003') + ' ' + contract">
						{{ $t('common.text_0010') }}: {{ contract }}
						<button type="button" class="tag-remove" @click="removeContract(contract)"
							:aria-label="$t('common.text_0003') + ' ' + contract">
							×
						</button>
					</span>
				</template>

				<template v-if="filterSearch.clientEmail">
					<span class="tag" role="button">
						E-mail: {{ filterSearch.clientEmail }}
						<button type="button" class="tag-remove" @click="removeClientIdentifier('clientEmail', filterSearch.clientEmail)"
						:aria-label="'email' + ' ' + filterSearch.clientEmail">×</button>
					</span>
				</template>

				<template v-if="filterSearch.clientDocument">
					<span class="tag" role="button">
						CPF/CNPJ: {{ filterSearch.clientDocument }}
						<button type="button" class="tag-remove" @click="removeClientIdentifier('clientDocument', filterSearch.clientDocument)"
						:aria-label="'document' + ' ' + filterSearch.clientDocument">×</button>
					</span>
				</template>

				<template v-for="affiliate in filterSearch.affiliates">
					<span v-if="affiliate" class="tag" role="button">
						Afiliados: {{ affiliate }}
						<button type="button" class="tag-remove" @click="removeTag('affiliates', affiliate)"
						:aria-label="$t('common.text_0003') + ' ' + filterSearch.affiliates.join(', ')">×</button>
					</span>
				</template>

				<template v-for="method in filterSearch.methods">
					<span v-if="method" class="tag" role="button">
						Métodos: {{ $t(`common.payment_method.${method}`) }}
						<button type="button" class="tag-remove" @click="removeTag('methods', method)"
						:aria-label="$t('common.text_0003') + ' ' + method">×</button>
					</span>
				</template>

				<template v-if="filterSearch.isSmartSale">
					<span class="tag" role="button">
						Venda Inteligente: Sim
						<button type="button" id="tag-formats-isSmartSale" class="tag-remove" @click="removeTag('isSmartSale', filterSearch.isSmartSale)"
						:aria-label="$t('common.text_0003') + ' ' + (filterSearch.isSmartSale ? 'Sim' : 'Não')">×</button>
					</span>
				</template>

				<template v-if="filterSearch.openCurrentInstallment">
				<span class="tag" role="button">
					Parcela corrente em aberto
					<button
					type="button"
					class="tag-remove"
					@click="removeOpenCurrentInstallment"
					aria-label="Remover Parcela corrente em aberto"
					>×</button>
				</span>
				</template>

				<template v-for="format in filterSearch.formats">
					<span v-if="format" class="tag" role="button">
						Tipo de Produto: {{ $t(`common.product.format.${format}`) }}
						<button :id="`tag-formats-${format}`" type="button" class="tag-remove" @click="removeTag('formats', format)"
						:aria-label="$t('common.text_0003') + ' ' + format">×</button>
					</span>
				</template>
			</div>

			<div class="container-table"
				style="margin-top: -20px !important; position: relative !important; max-width: 100% !important;">
				<div class="box-stateless"  style="max-width: 100% !important;">
          <TableReport :columns="columns" :rows="rows" :isLoading="loading" @getQuickView="getQuickView">
            <template #cell-status="{ row }">
              <div class="d-flex justify-content-center align-center ">
                <span class="mt-1  mr-2">{{row.contract_id}}</span>
                <div v-if="isAdvancedCourseFormat(row)" v-b-tooltip.hover class="btn-transparent mt-2" :title="getAdvancedCourseFormatTooltip(row)">
                  <img src="@/assets/svg/student-hat.svg" alt="Chapéu de estudante"/>
                </div>
              </div>
              <div class="d-flex justify-content-center m-2">
                <SubscriptionStatuses :status="normalizeStatus(row.status)" />
              </div>
            </template>
            <template #cell-client="{ row }">
              <div class="d-flex flex-column">
                <p class="mb-0 client-name">{{row.client_name }}</p>
                <a class="mb-0 font-weight-bold client-phone" :href="formatTelWhats(row.client_phone)" target="_blank">{{row.client_phone }}</a>
                <p class="mb-0 client-email">{{ row.client_email }}</p>
              </div>
            </template>
            <template #cell-receivables_total="{ row }">
              <div v-if="['ended', 'canceled'].includes(normalizeStatus(row.status))" class="d-flex justify-content-center">
                <span class="badge badge-ended">Encerrado</span>
              </div>
              <div v-else>
                {{ row.receivables_total }}
              </div>
            </template>
          </TableReport>
					<div v-if="rows.length > 0" class="d-flex align-items-center justify-content-end"
						style="border-top: 1px solid #dee2e6; height: 80px; margin-bottom: 10px; ">
						<Paginate :totalPages="pagination.totalPages" :activePage="pagination.currentPage" @to-page="toPage"
							@per-page="perPage" />
					</div>
				</div>
			</div>
			<ContractQuickView v-model="showQuickView" :contract-id="currentContractId"
				@update:contract-id="currentContractId = $event" ref="quickview" />
			<AdvancedFiltersModal @apply-advanced-filters="handleAdvancedFilters" ref="advancedFiltersModal" />
		</div>
	</div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import TableReport from "@/components/Seller/Reports/TableReport.vue";
import ContractQuickView from "@/components/Seller/Reports/ContractQuickView.vue";
import Paginate from '@/components/shared/Paginate';
import BaseDateRangePicker from '@/components/BaseDateRangePicker.vue';
import SubscriptionsReportService from "@/services/resources/SubscriptionsReportService.js";
import moment from 'moment-timezone';
import Multiselect from 'vue-multiselect';
import ProductsFilter from "@/components/shared/filters/ProductsFilter.vue";
import AdvancedFiltersModal from '@/components/Seller/Reports/modals/AdvancedFilters.vue';
import SubscriptionStatuses from "@/components/Seller/Reports/SubscriptionStatuses.vue";
import { subscriptionStatusLabel } from '@/helpers/subscriptionStatusTranslate';
import Utils from "@/mixins/utils";
import ExportModal from "@/components/ExportModal.vue";
import ClientIdentifierInput from "@/components/ClientIdentifierInput.vue";
import _ from "lodash";

const subscriptionsReportService = SubscriptionsReportService.build();

/** TODO: Refatorar componentes - melhorar lógica e separa em outros components  */

export default {
	components: {
    ClientIdentifierInput,
		BaseHeader,
		TableReport,
		Paginate,
		BaseDateRangePicker,
		Multiselect,
		ContractQuickView,
		ProductsFilter,
		AdvancedFiltersModal,
    SubscriptionStatuses,
    ExportModal
	},
  mixins: [Utils],
  data() {
		// Lê os status iniciais da store (caso existam)
		let initialStatus = [];
		try {
			const storeStatus = this.$store.getters.getSubscriptionStatus;
			if (storeStatus && typeof storeStatus === 'object') {
				initialStatus = Object.keys(storeStatus);
			}
		} catch (e) { }
		return {
      exportLoading: false,
			showQuickView: false,
			currentContractId: '',
			rows: [],
			columns: [
        { name: 'ID da Assinatura', fieldName: 'status' },
        {  name: 'Dados do cliente', fieldName: 'client' },
        { name: 'CPF/CNPJ', type: 'text', fieldName: 'document' },
        { name: 'Data de criação', type: 'date', fieldName: 'created_at' },
        { name: 'Próximo Vencimento', type: 'date', fieldName: 'current_period_end' },
        { name: 'Método de Pagamento', type: 'payment_method', fieldName: 'method' },
        { name: 'Parcela da Assinatura', type: 'text', fieldName: 'installments' },
        { name: 'Valor pago', type: 'currency', fieldName: 'total_amount_paid' },
        { name: 'Valor a receber', fieldName: 'receivables_total' },
        { name: 'Valor em atraso', type: 'currency', fieldName: 'overdue_total' },
        { name: 'Valor líquido', type: 'currency', fieldName: 'amount' },
        { name: 'Ações', type: 'icon', fieldName: 'actions' },
      ],
			filterSearch: {
				dateRange: {
					startDate: moment().subtract(30, "days").toDate(),
					endDate: moment().endOf("day").toDate(),
				},
				products: null,
				subscriptionStatus: initialStatus.length > 0 ? initialStatus : [],
				offers: [],
        clientDocument: '',
        clientEmail: '',
        openCurrentInstallment: false,
			},
			productsList: [],
			offersList: [],
			subscriptionStatusOptions: [
				{ id: 'trialing', name: this.getTranslatedStatus('trialing') },
				{ id: 'paid', name: this.getTranslatedStatus('paid') },
				{ id: 'unpaid', name: this.getTranslatedStatus('unpaid') },
				{ id: 'pending_payment', name: this.getTranslatedStatus('pending_payment') },
				{ id: 'canceled', name: this.getTranslatedStatus('canceled') },
				{ id: 'ended', name: this.getTranslatedStatus('ended') },
			],
			subscriptionStatus: {
				value: [],
				items: [],
			},
			loading: false,
			pagination: {
				totalPages: 1,
				currentPage: 1,
				perPage: 10
			},
			hasFilterFilled: false,
      clientIdentifier: '',
      clientIdentifierType: '',
		};
	},
	computed: {
		showMigrationBanner() {
			try {
				// exibe o banner enquanto a data atual for menor ou igual à data de descontinuação
				const discontinueDate = new Date('2026-01-15T23:59:59');
				const now = new Date();
				return now <= discontinueDate;
			} catch (e) {
				return true;
			}
		},
		filter() {
			return this.$store.getters.getFilters || {};
		},
	},
	created() {
		// Mostra no console que os status vieram do Main.vue via store
		this.initializeFilters();

		this.subscriptionStatus.items = [
			{
				group: { name: "Status" },
				options: this.subscriptionStatusOptions,
			},
		];

		this.fetchProductsList();
		this.fetchOffersList();
		const currentStatus = this.filterSearch.subscriptionStatus || [];

		if (Array.isArray(currentStatus) && currentStatus.length > 0) {
			this.subscriptionStatus.value = this.subscriptionStatusOptions.filter(opt =>
				currentStatus.includes(opt.id)
			);
		}
	},
	mounted() {
		this.openQuickViewFromRoute();
	},
	watch: {
		'filterSearch.dateRange': {
			handler(newDateRange) {
				const startDate = newDateRange.startDate
					? moment.tz(newDateRange.startDate, "America/Sao_Paulo").format("YYYY-MM-DDT00:00:00-03:00")
					: null;
				const endDate = newDateRange.endDate
					? moment.tz(newDateRange.endDate, "America/Sao_Paulo").format("YYYY-MM-DDT23:59:59-03:00")
					: null;

				this.$store.commit("setFilters", {
					startDate,
					endDate,
				});
				this.pagination.currentPage = 1;
			},
			deep: true
		},

	filterSearch: {
			handler() {
				this.hasFilterFilled = !!(
					this.filterSearch.products ||
					this.filterSearch.subscriptionStatus.length ||
					this.filterSearch.dateRange.startDate ||
					this.filterSearch.dateRange.endDate ||
          this.filterSearch.clientEmail ||
          this.filterSearch.clientDocument ||
					this.filterSearch.offers.length ||
          this.filterSearch.openCurrentInstallment
				);
        this.pagination.currentPage = 1;
			},
			deep: true,
		},
		'filterSearch.subscriptionStatus': {
			immediate: true,
			handler(newStatus) {
        this.pagination.currentPage = 1;
        if (Array.isArray(newStatus) && newStatus.length > 0) {
					this.subscriptionStatus.value = this.subscriptionStatusOptions.filter(opt =>
						newStatus.includes(opt.id)
					);
				} else {
					this.subscriptionStatus.value = [];
				}
			}
		},
    clientIdentifier(newValue) {
      this.handleClientIdentifier(this.clientIdentifierType, newValue);
    },
    clientIdentifierType(newType) {
      this.handleClientIdentifier(newType, this.clientIdentifier);
    }
	},
	methods: {
    normalizeStatus(status) {
      if (status === null || status === undefined) return "";
      return String(status).trim().toLowerCase();
    },
    handleClientIdentifier(type,value){
      this.pagination.currentPage = 1;
      if ('email' === type) {
        this.filterSearch.clientEmail = value;
        this.filterSearch.clientDocument = '';
      }
      if ('cpf' === type ||
          'cnpj' === type) {
        this.filterSearch.clientDocument = value;
        this.filterSearch.clientEmail = '';
      }
    },
    isExtensionCourse(row) {
      return row.product_format === 'EXTENSION_COURSE';
    },
    isPosGraduation(row) {
      return row.product_format === 'POS_GRADUATION';
    },
    isAdvancedCourseFormat(row) {
      return this.isExtensionCourse(row) || this.isPosGraduation(row);
    },
    getAdvancedCourseFormatTooltip(row) {
      if (this.isExtensionCourse(row)) {
        return this.$t('common.product.format.EXTENSION_COURSE');
      }
      if (this.isPosGraduation(row)) {
        return this.$t('common.product.format.POS_GRADUATION');
      }
      return '';
    },
		removeTag(filter, value) {
			if (Array.isArray(this.filterSearch[filter])) {
        this.filterSearch[filter] = this.filterSearch[filter].filter(item => item !== value);
				this.$refs.advancedFiltersModal?.setFilters({
					[filter]: this.filterSearch[filter],
				});
			}
			if (typeof this.filterSearch[filter] === 'string') {
				this.filterSearch[filter] = '';
				this.$refs.advancedFiltersModal?.setFilters({
					[filter]: this.filterSearch[filter],
				});
			}
      this.fetchReport();
		},
    openQuickViewFromRoute() {
			const contractId = this.$route.query.c_id;
			
			if (contractId) {
				this.getQuickView({ contract_id: contractId });
			}
		},
		toPage(page) {
			this.pagination.currentPage = page;
			this.fetchReport();
		},
		perPage(qtd) {
			this.pagination.currentPage = 1;
			this.pagination.perPage = qtd;
			this.fetchReport();
		},
    async handleExport({ email }) {
      try {
        this.exportLoading = true;

        const response = await subscriptionsReportService.export({
          type: "full",
          email,
          products: this.filterSearch.products || [],
          offers: this.filterSearch.offers || [],
          status: this.filterSearch.subscriptionStatus || [],
          startDate: this.filterSearch.dateRange.startDate.toISOString(),
          endDate: this.filterSearch.dateRange.endDate.toISOString(),
          contracts: this.filterSearch.contracts || [],
          clientEmail: this.filterSearch.clientEmail || '',
          clientDocument: this.filterSearch.clientDocument || '',
          affiliates: this.filterSearch.affiliates || [],
          methods: this.filterSearch.methods || [],
          isSmartSale: this.filterSearch.isSmartSale || '',
          formats: this.filterSearch.formats || [],
          ...(this.filterSearch.openCurrentInstallment && { openCurrentInstallment: true })
        });

        this.$bvToast.toast(
          response.message ? this.$t('seller.sales.wait_for_running_export_to_finish') : this.$t('seller.sales.text_2626'),
          {
            title: this.$t('seller.sales.text_2613'),
            variant: 'info',
            autoHideDelay: 5000,
            appendToast: true,
          }
        );
        this.$bvModal.hide('subscription-status-export-modal');
      } catch (e) {
        this.$bvToast.toast(this.$t('seller.sales.text_2831'), {
          title: this.$t('seller.sales.text_2613'),
          variant: 'danger',
          autoHideDelay: 5000,
          appendToast: true,
        });
      } finally {
        this.exportLoading = false;
      }
    },
		fetchReport() {
      // TODO: Paliativo para o excesso de requisições
      if(true === this.loading)
      {
        return;
      }

      this.loading = true;

			let filters;
			filters = {
				type: "full",
				page: this.pagination.currentPage,
				per_page: this.pagination.perPage,
				products: this.filterSearch.products || [],
				offers: this.filterSearch.offers || [],
				status: this.filterSearch.subscriptionStatus || [],
				startDate: this.filterSearch.dateRange.startDate.toISOString(),
				endDate: this.filterSearch.dateRange.endDate.toISOString(),
				contracts: this.filterSearch.contracts || [],
				clientEmail: this.filterSearch.clientEmail || '',
				clientDocument: this.filterSearch.clientDocument || '',
				affiliates: this.filterSearch.affiliates || [],
				methods: this.filterSearch.methods || [],
				isSmartSale: this.filterSearch.isSmartSale || '',
				formats: this.filterSearch.formats || [],
				...(this.filterSearch.openCurrentInstallment && { openCurrentInstallment: true })
			};


			subscriptionsReportService.search({ url: "", ...filters })
				.then((response) => {
					this.pagination.currentPage = response.current_page;
					this.pagination.totalPages = Math.ceil(response.total / response.per_page);
					this.rows = response.data;
					this.loading = false;
				})
				.catch((err) => {
					this.loading = false;
					const data = err?.response?.data;
					const apiMessage =
						(typeof data?.message === "string" && data.message) ||
						(typeof data?.error === "string" && data.error) ||
						null;
					this.$bvToast.toast(
						apiMessage || this.$t("seller.reports.text_2833"),
						{
							title: this.$t("views.contracts.text_972"),
							variant: "danger",
							autoHideDelay: 8000,
							appendToast: true,
						}
					);
				});
		},
		handleApplyFilterSubscriptionStatus(value) {
			const status = Array.isArray(value) ? value.map(item => item.id) : [];
			this.filterSearch.subscriptionStatus = status;
			this.subscriptionStatus.value = value;

			// Atualiza o status no modal também
			this.$nextTick(() => {
				this.$refs.advancedFiltersModal?.setStatus(status);
			});
			this.fetchReport();
		},
		handleRemoveFilterSubscriptionStatus(value) {
			if (Array.isArray(value)) {
				this.filterSearch.subscriptionStatus = [];
				this.subscriptionStatus.value = [];
			} else if (value && typeof value === 'object') {
				this.filterSearch.subscriptionStatus = this.filterSearch.subscriptionStatus.filter(
					(status) => status !== value.id
				);
				this.subscriptionStatus.value = this.subscriptionStatus.value.filter(
					(item) => item.id !== value.id
				);
			}
			this.fetchReport();
		},
		handleMultiselectInput(value) {
			this.subscriptionStatus.value = value;
		},
		isOptionSelected(type, option, force, obj) {
			let object = obj || this[type];
			return object?.value?.find(item => item.id === option) || force
				? require('@/assets/img/icons/checkbox-area-selected.svg')
				: require('@/assets/img/icons/checkbox-area.svg');
		},
		getTranslatedStatus(status) {
			return subscriptionStatusLabel(this.$t.bind(this), status);
		},
		handleClearFilters() {
			Object.assign(this.filterSearch, {
				dateRange: {
					startDate: moment().subtract(30, "days").toDate(),
					endDate: moment().endOf("day").toDate(),
				},
				subscriptionStatus: [],
				products: [],
				offers: [],
				contracts: [],
				clientEmail: '',
				clientDocument: '',
				affiliates: [],
				methods: [],
				isSmartSale: null,
				formats: [],
				openCurrentInstallment: false,
			});

			this.subscriptionStatus.value = [];
      this.clientIdentifier = '';
      this.clientIdentifierType = '';

      this.$store.commit('setFilters', { openCurrentInstallment: false });

			this.fetchReport();
		},
		getQuickView(rowData) {
			this.showQuickView = true;
			this.$refs.quickview.openPanel(rowData.contract_id, {
				installments: rowData.installments,
				status: this.normalizeStatus(rowData.status),
				method: rowData.method,
				amount: rowData.amount,
				client_name: rowData.client_name,
				client_email: rowData.client_email,
				document: rowData.document,
				cellphone: rowData.cellphone,
				start_date: rowData.start_date,
				current_period_end: rowData.current_period_end
			});
		},
		initializeFilters() {
			const {
        startDate,
        endDate,
        products,
        subscriptionStatus,
        offers,
        clientEmail,
        clientDocument,
        openCurrentInstallment,
      } = this.filter;

      this.filterSearch.clientDocument = clientDocument;
      this.filterSearch.clientEmail = clientEmail;
      this.filterSearch.openCurrentInstallment = openCurrentInstallment === true || openCurrentInstallment === 'true';

			this.filterSearch.dateRange = {
				startDate: startDate ? new Date(startDate) : moment().subtract(30, "days").toDate(),
				endDate: endDate ? new Date(endDate) : moment().endOf("day").toDate(),
			};

			this.filterSearch.products = products || null;
			//this.filterSearch.subscriptionStatus = subscriptionStatus || [];
			if (Array.isArray(subscriptionStatus) && subscriptionStatus.length > 0) {
				this.filterSearch.subscriptionStatus = subscriptionStatus;
			} else {
				// Se não vier nada, preenche com todos os status possíveis
				this.filterSearch.subscriptionStatus = this.subscriptionStatusOptions.map(opt => opt.id);
			}
			this.filterSearch.offers = offers || [];
		},
		openFiltersAdvanced() {
			// Garante que o status atual do componente pai seja refletido no modal
			const currentStatus = this.subscriptionStatus.value || [];
			const statusIds = currentStatus.map(item => item.id);
			this.$refs.advancedFiltersModal?.setFilters({
				products: this.filterSearch.products || [],
				offers: this.filterSearch.offers || [],
				status: statusIds,
				contracts: this.filterSearch.contracts || [],
				clientEmail: this.filterSearch.clientEmail || '',
				clientDocument: this.filterSearch.clientDocument || '',
				affiliates: this.filterSearch.affiliates || [],
				methods: this.filterSearch.methods || [],
				isSmartSale: this.filterSearch.isSmartSale || [],
				formats: this.filterSearch.formats || [],
				openCurrentInstallment: this.filterSearch.openCurrentInstallment === true,
			});

			// Força a atualização do status no modal
			this.$nextTick(() => {
				this.$refs.advancedFiltersModal?.setStatus(statusIds);
			});

			this.$bvModal.show('subscriptions-advanced-filters');
		},
		handleAdvancedFilters({ products, offers, status, contracts, clientEmail, clientDocument, affiliates, methods, isSmartSale, formats, openCurrentInstallment }) {
      this.filterSearch = {
				...this.filterSearch,
				product: null,
				products: Array.isArray(products)
				? products.map(p => typeof p === 'object' ? p.id : p)
				: [],
				offers,
				subscriptionStatus: status,
				contracts,
				clientEmail: clientEmail || '',
				clientDocument: clientDocument || '',
				affiliates: affiliates || [],
				methods: methods || [],
				isSmartSale: isSmartSale || null,
				formats: formats || [],
				openCurrentInstallment: openCurrentInstallment === true,
			};

      if(clientEmail){
        this.clientIdentifier = clientEmail;
      }

      if(clientDocument) {
        this.clientIdentifier = clientDocument;
      }


			// Atualiza o status no componente pai
			if (Array.isArray(status)) {
				this.subscriptionStatus.value = this.subscriptionStatusOptions.filter(opt => status.includes(opt.id));
			} else {
				this.subscriptionStatus.value = [];
			}

			if (!this.filterSearch.dateRange || !this.filterSearch.dateRange.startDate || !this.filterSearch.dateRange.endDate) {
				this.filterSearch.dateRange = {
					startDate: moment().subtract(30, "days").toDate(),
					endDate: moment().endOf("day").toDate(),
				};
			}

			// Sincroniza datas no store para manter padrão da URL
			const startDate = this.filterSearch.dateRange.startDate
				? moment.tz(this.filterSearch.dateRange.startDate, "America/Sao_Paulo").format("YYYY-MM-DDT00:00:00-03:00")
				: null;
			const endDate = this.filterSearch.dateRange.endDate
				? moment.tz(this.filterSearch.dateRange.endDate, "America/Sao_Paulo").format("YYYY-MM-DDT23:59:59-03:00")
				: null;

			this.$store.commit("setFilters", {
				...this.filter,
				startDate,
				endDate,
				products: this.filterSearch.products,
				offers: this.filterSearch.offers,
				subscriptionStatus: this.filterSearch.subscriptionStatus,
				contracts: this.filterSearch.contracts,
				clientEmail: this.filterSearch.clientEmail || null,
				clientDocument: this.filterSearch.clientDocument || null,
				affiliates: affiliates || [],
				methods: methods || [],
				isSmartSale: isSmartSale || null,
				formats: formats || [],
				openCurrentInstallment: this.filterSearch.openCurrentInstallment === true,
			});

			this.fetchOffersList();

			this.fetchReport();
		},
		getProductName(id) {
			const p = this.productsList.find(p => p.id === id);
			return p ? p.name : id;
		},
		getOfferName(id) {
			const o = this.offersList.find(o => o.id === id);
			return o ? o.name : id;
		},
		getStatusName(id) {
			const s = (this.subscriptionStatusOptions || []).find(s => s.id === id);
			return s ? s.name : id;
		},
		removeProduct(id) {
			// 1. Remove o produto do filtro
			this.filterSearch.products = (this.filterSearch.products || []).filter(p => p !== id);

			// 2. Recarrega a lista de ofertas válidas dos produtos restantes
			const produtosRestantes = this.filterSearch.products || [];
			// Busca todas as ofertas dos produtos restantes
			this.fetchOffersList().then(() => {
				// 3. Atualiza o filtro de ofertas mantendo apenas ofertas válidas dos produtos restantes
				const ofertasValidas = this.offersList.map(oferta => oferta.id);
				this.filterSearch.offers = (this.filterSearch.offers || []).filter(offerId => ofertasValidas.includes(offerId));

				// 4. Sincroniza o modal
				this.$refs.advancedFiltersModal?.setFilters({
					products: produtosRestantes,
					offers: this.filterSearch.offers,
					status: this.filterSearch.subscriptionStatus || [],
					contracts: this.filterSearch.contracts || []
				});

				// 5. Atualiza a tabela
				this.fetchReport();
			});
		},
		removeOffer(id) {
			this.filterSearch.offers = this.filterSearch.offers.filter(o => o !== id);
			this.fetchReport();
		},
		removeStatus(id) {
			// Remove o status selecionado do filtro
			this.filterSearch.subscriptionStatus = (this.filterSearch.subscriptionStatus || []).filter(s => s !== id);

			// Atualiza o multiselect visualmente (removendo o item)
			this.subscriptionStatus.value = (this.subscriptionStatus.value || []).filter(item => item.id !== id);

			// Atualiza o modal de filtros avançados, se existir
			this.$refs.advancedFiltersModal?.setStatus(this.filterSearch.subscriptionStatus);

			// Atualiza no Vuex também para manter sincronia
			this.$store.commit("setFilters", {
				subscriptionStatus: this.filterSearch.subscriptionStatus,
			});

			// Recarrega a tabela
			this.fetchReport();
		},
		removeContract(id) {
			this.filterSearch.contracts = this.filterSearch.contracts.filter(c => c !== id);
			this.fetchReport();
		},
    removeClientIdentifier(filter, value) {
      this.removeTag(filter, value);
      this.clientIdentifier = '';
      this.filterSearch.clientEmail = '';
      this.filterSearch.clientDocument = '';
    },
    removeOpenCurrentInstallment() {
      this.filterSearch.openCurrentInstallment = false;
      this.$refs.advancedFiltersModal?.setOpenCurrentInstallment(false);
      this.$store.commit('setFilters', { openCurrentInstallment: false });
      this.fetchReport();
    },
		async fetchProductsList() {
			// Busca a lista de produtos para exibir o nome na tag
			try {
				const ProductService = (await import('@/services/resources/ProductService')).default;
				const serviceProduct = ProductService.build();
				const data = { list: true, with_participants: true };
				const products = await serviceProduct.search(data);
				this.productsList = products.map(({ id, name }) => ({ id, name }));
			} catch (e) {
				this.productsList = [];
			}
		},
		async fetchOffersList() {
			// Busca a lista de ofertas para exibir o nome na tag
			try {
				const OfferService = (await import('@/services/resources/OfferService')).default;
				const offerService = OfferService.build();
				// Busca todas as ofertas relacionadas aos produtos selecionados
				let productIds = this.filterSearch.products || [];
				if (!Array.isArray(productIds)) productIds = [];
				if (productIds.length === 0) {
					this.offersList = [];
					return;
				}
				const response = await offerService.search({ url: '/products', products: productIds });
				// response é um array de grupos, cada grupo tem offerOptions
				let allOffers = [];
				if (Array.isArray(response)) {
					for (const group of response) {
						if (group.offerOptions) {
							allOffers = allOffers.concat(group.offerOptions);
						}
					}
				}
				this.offersList = allOffers;
			} catch (e) {
				this.offersList = [];
			}
		},
    debounce: _.debounce(function () {
      this.fetchReport();
    }, 1000),

	}
};
</script>

<style scoped>
.tag {
	background: #eef2ff;
	color: #2a63ab;
	border: 1px solid #2a63ab;
	border-radius: 6px;
	padding: 4px 8px;
	font-size: 12px;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	height: 24px;
	transition: all 0.2s ease;
	font-weight: 500;
	margin: .125rem .25rem .125rem 0;
}

.tag-remove {
	cursor: pointer;
	font-size: 14px;
	width: 16px;
	height: 16px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background-color: rgba(42, 99, 171, 0.1);
	transition: all 0.2s ease;
	line-height: 1;
	padding: 0;
	border: none;
	color: #2a63ab;
	font-weight: bold;
}

.tag-remove:hover {
	background-color: rgba(42, 99, 171, 0.2);
	transform: scale(1.1);
}

.applied-filters {
	margin: 2px 0 6px 0 !important;
	padding-top: 8px !important;
}

::v-deep(.new-style .multiselect__tags) {
	margin-top: 0 !important;
}

.box-stateless {
	border: 1px solid #D7DAE2;
	box-sizing: border-box;
	border-radius: 8px;
	width: 100%;
	max-width: 1660px;
}

.container-x {
	display: flex;
	flex-direction: column;
	gap: 24px;
	padding-bottom: 24px;
}

.base-date-picker {
	min-width: 170px;
	max-width: 180px;
}

.badge-ended {
  background: #F2F4F7;
  color: #344054;
}

.migration-banner {
	background: #E6F0FF; /* light blue */
	border: 1px solid #BFD7FF;
	color: #0b3a78;
	margin: 16px 0;
}
.migration-banner .migration-text a {
	color: #083a8a;
	font-weight: 700;
}
</style>
